import { CmStreamType } from '@svta/cml-cta'

/**
 * Common Media Server Data Stream Type
 *
 *
 * @enum
 *
 * @public
 */
export const CmsdStreamType = CmStreamType as typeof CmStreamType

/**
 * @public
 */
export type CmsdStreamType = CmStreamType;
